import React from 'react';

import {SchemaTag} from 'folder-items/FileConstants';
import {ALLOWED_TIMEZONE} from 'graphql-client/__generated/GeneratedEnumMaps';
import {ConnectionFieldType} from 'instruments/connections/ConnectionConstants';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import {RadioButtonSelector} from 'ui-library/inputs/RadioButtonGroup';
import SecureTextInput from 'ui-library/inputs/SecureTextInput';
import Menu from 'ui-library/menus/Menu';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

function getTimezoneEditor(
  tag: SchemaTag,
  autoFocus: boolean,
  onChange: (newValue: Partial<SchemaTag>) => void
): JSX.Element {
  return (
    <SelectDropdown
      menu={
        <SearchableMenu
          selectedValue={tag.value}
          optionDatas={Object.values(ALLOWED_TIMEZONE).map((tz) => ({
            name: tz,
            value: tz,
          }))}
          onSelect={(timezone: string | null) => {
            onChange({value: timezone});
          }}
          height={Menu.HEIGHTS.MEDIUM}
          width={Menu.WIDTHS.LARGE}
          scrollable={true}
        />
      }
      displayName={tag.value}
      autoFocus={autoFocus}
    />
  );
}

function getSecureEditor(
  tag: SchemaTag,
  autoFocus: boolean,
  onChange: (newValue: Partial<SchemaTag>) => void
): JSX.Element {
  return (
    <SecureTextInput
      name={tag.name}
      value={tag.value || null}
      onChange={(newValue: string) => {
        onChange({value: newValue});
      }}
      disabled={false}
      description={`After saving ${tag.name.toLowerCase()} this will no longer be visible.`}
    />
  );
}

function getPerUserLoginRequiredEditor(
  tag: SchemaTag,
  autoFocus: boolean,
  onChange: (newValue: Partial<SchemaTag>) => void
): JSX.Element {
  return (
    <RadioButtonSelector
      selectedValue={tag.value}
      options={[
        {label: 'True', value: 'true'},
        {label: 'False', value: 'false'},
      ]}
      onChange={(perUserLoginRequired: string) => {
        onChange({value: perUserLoginRequired});
      }}
    />
  );
}

export default function getCustomTagEditors(fieldTypes: {[id: string]: string | null}): {
  [id: string]: (
    tag: SchemaTag,
    autoFocus: boolean,
    onChange: (newValue: Partial<SchemaTag>) => void
  ) => JSX.Element;
} {
  const customEditors: {
    [id: string]: (
      tag: SchemaTag,
      autoFocus: boolean,
      onChange: (newValue: Partial<SchemaTag>) => void
    ) => JSX.Element;
  } = {
    default_timezone: getTimezoneEditor,
    per_user_login_required: getPerUserLoginRequiredEditor,
  };
  Object.entries(fieldTypes).forEach(([fieldName, fieldType]) => {
    if (fieldType === ConnectionFieldType.SECRET_REF) {
      customEditors[fieldName] = getSecureEditor;
    }
  });
  return customEditors;
}
